export default __webpack_public_path__ + "static/media/Close.e13fda77.svg";